/**
 * usePortalPermissions
 *
 * Hook que expõe helpers para checar permissions do portal externo.
 * Lê o Set<string> de permissions do PortalAuthContext (derivado do
 * claim `permissions` do JWT de acesso).
 *
 * Uso:
 *   const { has, hasAny, hasAll } = usePortalPermissions();
 *   if (has("portal:financeiro:view")) { ... }
 */
import { usePortalAuth } from "@/contexts/PortalAuthContext";

export interface UsePortalPermissionsReturn {
  permissions: Set<string>;
  has: (perm: string) => boolean;
  hasAny: (perms: string[]) => boolean;
  hasAll: (perms: string[]) => boolean;
}

export function usePortalPermissions(): UsePortalPermissionsReturn {
  const { permissions } = usePortalAuth();
  return {
    permissions,
    has: (perm: string): boolean => permissions.has(perm),
    hasAny: (perms: string[]): boolean => perms.some((p) => permissions.has(p)),
    hasAll: (perms: string[]): boolean => perms.every((p) => permissions.has(p)),
  };
}

export default usePortalPermissions;
